// local
import Api from '.';

export function reportByPatient(data) {
    return Api.post('/report/by-patient', data);
}

export function reportDailyConsumption(data) {
    return Api.post('/report/daily', data);
}

export function reportDailyConsumptionExport(data) {
    return Api.download('/report/daily/export', data);
}

export function reportPrescription(data) {
    return Api.post('/report/prescription', data);
}

export function reportByPatientExport(data) {
    return Api.download('/report/by-patient/export', data);
}

export function reportChangeByPatient(data){
    return Api.post('/report/cylinderChangesByOPatient', data);
}

export function reportChangeBySupplier(data){
    return Api.post('/report/cylinderChangesBySupplier', data);
}

export function reportChanges(data){
    return Api.post('/report/cylinderChanges', data);
}

export function reportByGeneral(data) {
    return Api.post('/report/by-general', data);
}

export function reportByGeneralExport(data) {
    return Api.download('/report/by-general/export', data);
}

export function reportBySupplier(data) {
    return Api.post('/report/by-supplier', data);
}

export function reportBySupplierExport(data) {
    return Api.download('/report/by-supplier/export', data);
}

export function reportChangeByPatientExport(data){
    return Api.download('/report/cylinderChangesByOPatient/export', data);
}

export function reportChangeBySupplierExport(data){
    return Api.download('/report/cylinderChangesBySupplier/export', data);
}

export function reportChangesExport(data){
    return Api.download('/report/cylinderChanges/export', data);
}
